module.exports = __webpack_public_path__ + "static/media/building_326.809e2385.png";